import React from 'react';
import {Images} from '../../assets';
import './styles.scss';

export const Header: React.FC = () => {
  return (
    <div className="header">
      <div className="container h-100">
        <div className="row h-100 align-items-center justify-content-center">
          <div className="col-6 d-flex justify-content-center">
            <a href={process.env.REACT_APP_RECCO_MARKETING_URL} target="_blank" rel="noreferrer">
              <img src={Images.LOGO} className="logo" alt="Recco Logo" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
